import {
    SET_JOB_TITLE,
    SET_CAREER_CLUSTER,
    SET_JOB_DESCRIPTION,
    SET_IS_GREEN,
    SET_IS_BRIGHT,
    SET_SKILL_LEVEL,
    SET_SEARCH_TYPE,
    SET_SELECTED_INDEX,
    SET_SHOW_SKILL_LEVELS,
    SET_SELECTED_SKILL,
    SHOW_VIDEO_PLAYER,
} from "./actions";

import { filteredState } from "./selectors";

const selectedReducer = (state, action) => {
    return filteredState(rootReducer(state, action));
};

const rootReducer = (state, action) => {
    // console.log(action);
    switch (action.type) {
        case SET_JOB_TITLE:
            return Object.assign({}, state, {
                jobTitle: action.payload,
            });
        case SET_CAREER_CLUSTER:
            return Object.assign({}, state, {
                careerCluster: action.payload,
            });
        case SET_JOB_DESCRIPTION:
            return Object.assign({}, state, {
                jobDescription: action.payload,
            });
        case SET_IS_GREEN:
            return Object.assign({}, state, {
                isGreen: action.payload,
            });
        case SET_IS_BRIGHT:
            return Object.assign({}, state, {
                isBright: action.payload,
            });
        case SET_SKILL_LEVEL:
            return Object.assign({}, state, {
                [action.key]: action.level,
            });
        case SET_SEARCH_TYPE:
            return Object.assign({}, state, {
                searchtype: parseInt(action.val, 10),
            });
        case SET_SELECTED_INDEX:
            let new_index = action.index;
            if (new_index >= state.filteredJobs.length) new_index = 0;
            if (new_index < 0) new_index = state.filteredJobs.length - 1;
            return Object.assign({}, state, {
                selectedIndex: new_index,
                videoPlayerVisible: false,
            });
        case SET_SHOW_SKILL_LEVELS:
            return Object.assign({}, state, {
                showSkillLevels: action.show,
            });
        case SET_SELECTED_SKILL:
            return Object.assign({}, state, {
                selectedSkill: action.skill,
            });
        case SHOW_VIDEO_PLAYER:
            return Object.assign({}, state, {
                videoPlayerVisible: action.show,
            });

        default:
            return state;
    }
};

export default selectedReducer;
